<template>
  <div class="container mx-auto px-4 h-full">
    <div class="flex content-center items-center justify-center h-full">
      <div class="w-full lg:w-4/12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0"
        >
          <div class="rounded-t mb-0 px-6 py-6">
            <div class="text-center mb-3">
              <h6 class="text-blueGray-500 text-sm font-bold">Sign in with</h6>
            </div>
            <hr class="mt-6 border-b-1 border-blueGray-300" />
          </div>
          <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
            <div>
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Email
                </label>
                <input
                  type="email"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Email"
                  v-model="form.email"
                />
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Password
                </label>
                <input
                  type="password"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Password"
                  v-model="form.password"
                />
              </div>

              <div class="text-center mt-6">
                <button
                  class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  type="button"
                  @click="handleLogin"
                >
                  Sign In
                </button>
              </div>
            </div>
            <div
              v-if="this.error.show || this.userErrors != null"
              class="text-white px-6 py-4 border-0 rounded bg-red-500"
            >
              <span class="text-xl mr-3 align-middle">
                <i class="fas fa-bell"></i>
              </span>
              <span class="align-middle">
                {{ this.error.show ? this.error.message : this.userErrors }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import router from "@/router";
import { LOGIN } from "@/store/actions.type";

export default {
  name: "Login",
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      error: {
        show: false,
        message: ""
      }
    };
  },
  computed: {
    ...mapGetters(["userErrors"])
  },
  methods: {
    handleLogin() {
      this.error = { show: false, message: "" };
      if (this.form.email && this.form.password) {
        this.$store
          .dispatch(LOGIN, {
            email: this.form.email,
            password: this.form.password
          })
          .then(() => {
            router.push({ name: "admin" });
          });
      } else {
        this.error = {
          show: true,
          message: "Please enter email and password."
        };
      }
    }
  }
};
</script>
